import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {Account} from "../interface/account";

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/account/${id}`);
  }
  getCollection(): Observable<Account[]>{
    return this.http.get<Account[]>(`${this.baseUrl}/get/accounts`);
  }

  post(data: Account): Observable<any>{
    return this.http.post<Account>(`${this.baseUrl}/create/account`, data);
  }

  import(datas: any[]): Observable<any>{
    console.log(datas);
    let options = {data: datas};
    return this.http.post(`${this.baseUrl}/import/account`, options);
  }
  put(id: number, data: Account): Observable<any>{
    return this.http.put<Account>(`${this.baseUrl}/edit/account/${id}`, data);
  }

  delete(id: number): Observable<Account>{
    return this.http.delete<Account>(`${this.baseUrl}/delete/account/` + id);
  }

  deleteMultiple(ids: number[]): Observable<Account[]>{
    const options = {body: ids};
    return this.http.delete<Account[]>(`${this.baseUrl}/delete/selected/account`, options);
  }

}
